import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import {
  Chat,
  HubChatHistorico,
  Message,
  NotifySignalR,
  ReconexionChat,
  RequestChatsHistorico,
  RequestConexionSignalR,
  RequestUsuariosActivos,
  ResponseUSer,
} from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { SignalRService } from 'src/app/_services/signal-r.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chat-signal-r',
  templateUrl: './chat-signal-r.component.html',
  styleUrls: ['./chat-signal-r.component.css'],
})
export class ChatSignalRComponent implements OnInit, AfterViewInit, OnDestroy {
  idUsuarios: string;
  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  currentUser: ResponseUSer;
  mySubscription: any;
  datos: RequestUsuariosActivos[];
  txtMessage: string = '';
  uniqueID: string = new Date().getTime().toString();
  messages = new Array<Message>();
  message: Message;
  ArrayUsuarios: RequestUsuariosActivos[];
  idNuevoMensaje: string;
  ArrayChatsHistorico: RequestChatsHistorico[];
  ArrayChatsHistoricoHub: HubChatHistorico[];
  folioChat: any;
  enviados = true;
  ContenedorUsuariosActivos = false;
  ButtonNuevoMensaje = true;
  contenedorChat = false;
  ContenedorHoraSErver: any;
  conexion: RequestConexionSignalR;
  ReloadarrayMessage: ReconexionChat;
  constructor(
    public chatService: SignalRService,
    private _ngZone: NgZone,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((events) => {
        this.authenticationService.currentUser.subscribe(
          (x) => (this.currentUser = x)
        );
      });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd');
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    });
    this.ArrayUsuarios = [];
    this.datos = [];
  }
  ngOnInit(): void {
    this.chatService = new SignalRService(this.authenticationService);
    this.OnChangeLoader();
    this.signa();

    this.UsuariosActivos();
    this.HubChatHistorico();
    this.notificacion();
    this.SignalRDateTimeServer();
    this.subscribeToEvents();
    this.SignalRChatsHistorico();

    // this.signalRService.startConnection();
    //this.signalRService.addTransferChartDataListener();
  }

  ngAfterViewInit(): void {
    //  this.startHttpRequest();

    const main = <HTMLInputElement>document.getElementById('SubMenu');

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap((event) => {
          console.log('show');
          main.style.display = 'block';
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
        })
      )
      .subscribe((val) => {
        console.log('hide');
        main.style.display = 'none';
      });

    this.OnMostrarUsuarios();

    // this.OnRequestChatsHistorico();
  }
  ngOnDestroy(): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';

    localStorage.setItem('header', '0');
  }
  sendMessage(): void {
    var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario
    if (this.txtMessage) {
      var data =
        this.idUsuarios +
        '|' +
        json.useremail +
        '|App-Werehouse|' +
        json.company +
        '|' +
        this.idNuevoMensaje;
      this.message = {
        clientuniqueid: data,
        type: 'sent',
        message: this.txtMessage,
        date: new Date(),
      };

      //this.messages.push(this.message);
      this.chatService.sendMessage(this.message);
      this.txtMessage = '';
    }
  }
  private subscribeToEvents(): void {
    this.chatService.messageReceived.subscribe((message: Message) => {
      this._ngZone.run(() => {
        this.messages.push(message);
      });
    });
  }
  private UsuariosActivos(): void {
    this.chatService.usuariosActivos.subscribe(
      (Usuarios: RequestUsuariosActivos[]) => {
        this._ngZone.run(() => {
          this.ArrayUsuarios = Usuarios;
        });
      }
    );
  }
  private SignalRChatsHistorico(): void {
    this.chatService.ArrayChatsHistorico.subscribe(
      (chats: RequestChatsHistorico[]) => {
        this._ngZone.run(() => {
          this.ArrayChatsHistorico = chats;
        });
      }
    );
  }
  private SignalRDateTimeServer(): void {
    this.ContenedorHoraSErver = this.chatService.Hora;
  }
  private HubChatHistorico(): void {
    this.chatService.ArrayChatsHistoricoHub.subscribe(
      (chats: HubChatHistorico[]) => {
        this._ngZone.run(() => {
          this.ArrayChatsHistoricoHub = chats;
          this.OnChangeChatsHistorico(
            this.ArrayChatsHistoricoHub[0].registros[0].chat,
            this.ArrayChatsHistoricoHub[0].registros[0].folio_chat
          );
        });
      }
    );
  }
  private signa(): void {
    this.chatService.idSignalR.subscribe((chats: string) => {
      this._ngZone.run(() => {
        this.idUsuarios = chats;
        console.log(chats, 'signal');
      });
    });
  }

  private startHttpRequest = () => {
    var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario
    this.http
      .get(
        `${environment.apiSignalR}/api/ClientOptions/UsuariosActivos?usuario=` +
          json.useremail +
          `&plataforma=App-Werehouse`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((res: RequestUsuariosActivos[]) => {
        this.ArrayUsuarios = res;
        console.log(res);
      });
  };
  OnRequestChatsHistorico() {
    var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario
    this.http
      .get(
        `${environment.apiSignalR}/api/ClientOptions/ChatsHistorico?idUsuario=` +
          this.idUsuarios,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((res: Message[]) => {
        this.messages = res;
        this.enviados = true;
        console.log(res);
      });
  }
  OnNuevoMensaje(data: any) {
    this.contenedorChat = true;
    this.messages = [];
    this.idNuevoMensaje = String(data);
    this.ContenedorUsuariosActivos = false;
  }
  randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  OnChangeChatsHistorico(data: Chat[], envio: any) {
    this.contenedorChat = true;
    // this.ContenedorUsuariosActivos = false;
    this.messages = [];
    console.log(data);
    this.idNuevoMensaje = String(envio);
    data.forEach((element) => {
      if (this.idUsuarios == String(element.id_usuario)) {
        var ms = 'sent';
        this.message = {
          clientuniqueid: String(element.id_chat),
          type: ms,
          message: element.mensaje_chat,
          date: element.fecha_chat,
        };
        this.messages.push(this.message);
      } else {
        //this.idNuevoMensaje = String(element.id_usuario);
        var ms = 'received';
        this.message = {
          clientuniqueid: String(element.id_chat),
          type: ms,
          message: element.mensaje_chat,
          date: element.fecha_chat,
        };
        this.messages.push(this.message);
      }
    });
  }
  OnMostrarUsuarios() {
    this.ContenedorUsuariosActivos = true;

    //  this.messages = [];
  }
  private notificacion(): void {
    this.chatService.Notificacio.subscribe((Usuarios: NotifySignalR) => {
      this._ngZone.run(() => {
        if (Usuarios.method == 'NotifyMessage') {
          var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario

          //this.startHttpRequest();
          this.Toast.fire({
            icon: 'success',
            title: Usuarios.arg[0].arg,
          });
          this.ReloadarrayMessage = {
            Useremail: json.useremail,
            plataforma: 'App-Werehouse',
            companyId: String(json.company),
            ClientId: String(this.idNuevoMensaje),
          };
          this.chatService.ReloadChatMessage(this.ReloadarrayMessage);
        } else if (Usuarios.method == 'NotifyReloadCallServer') {
          console.log('reloadSystem', this.idNuevoMensaje);
          if (this.idNuevoMensaje != undefined) {
            console.log('reload-cliente-sms');
            var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario
            this.ReloadarrayMessage = {
              Useremail: json.useremail,
              plataforma: 'App-Werehouse',
              companyId: String(json.company),
              ClientId: String(this.idNuevoMensaje),
            };
            this.chatService.ReloadChatMessage(this.ReloadarrayMessage);
          }
          this.OnReconexionHub();
          console.log('OnReconexionHub');
          //this.startHttpRequest();
          console.log('startHttpRequest');

          //this.OnRequestChatsHistorico();
        }
      });
    });
  }
  OnReconexionHub() {
    var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario

    this.conexion = {
      Useremail: json.useremail,
      plataforma: 'App-Werehouse',
      companyId: String(json.company),
    };
    this.chatService.ConexionSignalR(this.conexion);
    this.chatService.ConexionChatHistorico(this.conexion);
    this.chatService.ConexionChatUsers(this.conexion);
    this.OnMostrarUsuarios();
  }
  OnChangeLoader() {
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 15000);
  }
  filterData(locationName: Number) {
    return this.ArrayUsuarios.filter((object) => {
      if (object['id'] == locationName) {
        return object;
      }
    });
  }
  filterDatar(locationName: Number) {
    console.log(locationName);
    if (locationName != undefined) {
      this.datos = this.filterData(locationName);
      return this.datos[0].plataforma;
    }
  }
  filterDatarDate(locationName: Number) {
    console.log(locationName);
    if (locationName != undefined) {
      this.datos = this.filterData(locationName);
      return this.datos[0].ultimaves;
    }
  }
  filterDatarStatus(locationName: Number) {
    console.log(locationName);
    if (locationName != undefined) {
      this.datos = this.filterData(locationName);
      return this.datos[0].estatus;
    }
  }
}
